import { useTranslation } from 'react-i18next';
import { Dropdown, Flex, Menu } from 'antd';
import type { MenuInfo } from 'rc-menu/lib/interface';
import { useClearFavorite } from 'api/favorites/use-clear-favorite';
import { useCreateFavorites } from 'api/favorites/use-create-favorites';
import type { TFavoriteColors } from 'api/swagger';
import { favoriteColorMapping } from 'types/favorites';
import { FavoriteColorCircle } from '../favorite-color-circle';
import { EAction, type IColorsDropdownProps } from './types';

export const ColorsDropdown: React.FC<IColorsDropdownProps> = (props) => {
  const { cargoIds, markedColors = [], children } = props;
  const { t } = useTranslation('favorite');
  const { mutate: createFavorite } = useCreateFavorites();
  const { mutate: clearFavorite } = useClearFavorite();

  const handleMenuClick = (e: MenuInfo) => {
    const color = e.key as TFavoriteColors;
    const action = markedColors.includes(color) ? EAction.Clear : EAction.Add;

    if (action === EAction.Add) {
      createFavorite({
        cargoIds: cargoIds,
        color,
      });
    } else if (action === EAction.Clear) {
      clearFavorite({
        cargoId: cargoIds[0],
        color,
      });
    } else {
      console.error(`Unhandled action type: ${action}`);
      throw new ReferenceError(`Unhandled action type: ${action}`);
    }
  };

  const favoriteColorsEntries = Object.entries(favoriteColorMapping) as [TFavoriteColors, string][];

  const renderMenuItems = () => {
    return favoriteColorsEntries.map(([key, val]) => (
      <Menu.Item key={key}>
        <Flex align='center' justify='flex-start' gap={8}>
          <FavoriteColorCircle backgroundColor={val} />
          <span>{markedColors.includes(key) ? t('clear_mark') : t('add_mark')}</span>
        </Flex>
      </Menu.Item>
    ));
  };

  const menu = <Menu onClick={handleMenuClick}>{renderMenuItems()}</Menu>;

  return (
    <Dropdown overlay={menu} trigger={['click']}>
      {children}
    </Dropdown>
  );
};
